module.exports = __webpack_public_path__ + "catalog/items/firesafety/Evacuation-Chair/Evacuation-Chair.svg";